<div class="embeded-toolbar">
    <dx-drop-down-button
        icon="menu"
        stylingMode="text"
        [text]="currentPage()?.text ?? 'เลือกหน้า'"
        [items]="pages"
        displayExpr="text"
        keyExpr="path"
        [dropDownOptions]="{ minWidth: 220 }"
        (onItemClick)="onPageClick($event)"
    ></dx-drop-down-button>
    <div class="page-menu">
        @if (headerContent.content(); as pageMenu) {
        <ng-container [ngTemplateOutlet]="pageMenu"></ng-container>
        }
    </div>
    <span class="version">v{{ packageInfo.version }}</span>
</div>

<div class="content">
    <ng-content></ng-content>
</div>
